var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmploymentEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4756 7.10425L4.81855 14.7614C4.53639 15.044 4.35807 15.4138 4.31254 15.8106L4.00744 18.4894C3.98756 18.6778 4.00763 18.8683 4.06635 19.0484C4.12508 19.2285 4.22113 19.3942 4.34824 19.5346C4.47535 19.6751 4.63065 19.7871 4.80401 19.8635C4.97738 19.9398 5.16489 19.9788 5.35432 19.9777H5.51059L8.18946 19.6726C8.58467 19.6269 8.95362 19.4516 9.23868 19.174L16.8958 11.5095L12.4756 7.10425Z",
    fill: "#1253FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.4853 6.45682L17.5432 4.51464C17.3807 4.35152 17.1876 4.22209 16.975 4.13378C16.7624 4.04546 16.5344 4 16.3042 4C16.0739 4 15.846 4.04546 15.6334 4.13378C15.4208 4.22209 15.2277 4.35152 15.0652 4.51464L13.2644 6.31544L17.6845 10.7356L19.4853 8.93478C19.6485 8.77231 19.7779 8.57922 19.8662 8.36661C19.9545 8.15399 20 7.92603 20 7.6958C20 7.46557 19.9545 7.23761 19.8662 7.025C19.7779 6.81238 19.6485 6.6193 19.4853 6.45682Z",
    fill: "#1253FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentEditPencil);
export default __webpack_public_path__ + "static/media/employment-edit-pencil.bfbeb363fa4a03e6f7923a0192ba47b6.svg";
export { ForwardRef as ReactComponent };